import React from 'react';

import Label from './Label';
import { Virtuoso } from 'react-virtuoso';
import { Mission, SampleBox } from '../../../db';
import { SampleErrorMap, SettingsAccessLevel } from '../../../types/types';
import { LabelMap, LabelViewData } from './MissionLabels';

interface LabelCollectionProps {
  mission: Mission;
  barcodeHandler: (sampleInstanceId: number, sampleId: string) => Promise<void>;
  errMap: SampleErrorMap;
  sampleHandler: (sampleInstanceId: number) => Promise<void>;
  currentSampleId: string;
  currentSampleInstanceId: number;
  labels: LabelMap;
  moveSample: (sampleId: number, toBoxInstanceId: number) => Promise<void>;
  activeBox: SampleBox | undefined;
  allBoxes: SampleBox[];
  photosBySampleId: Record<string, any[]>;
  onCoresButtonClick: (sampleID: string) => void;
  strictCoreEnforcement: boolean;
  accessLevel: SettingsAccessLevel;
}

export default React.memo(
  React.forwardRef(function LabelCollection(props: LabelCollectionProps, _ref: any) {
    const labelsKeys = Object.keys(props.labels).sort((a, b) => {
      return props.labels[a].order - props.labels[b].order;
    });

    const labelsOrdered = labelsKeys.map((l) => props.labels[l]);

    const itemContent = (index: number, label: LabelViewData) => {
      const itemKey = labelsKeys[index];
      const noActiveBox = !props.activeBox;
      const boxClosed = Boolean(label.box && label.box.closed);
      const photos = props.photosBySampleId[itemKey] || [];

      return (
        <div>
          <Label
            sampleId={itemKey}
            barcodeId={label.bagId}
            sampleBox={label.box}
            sampleInstanceId={label.instanceId}
            currentBoxUid={props.activeBox?.uid}
            disabled={noActiveBox || (boxClosed && props.accessLevel !== 'Technician') || props.strictCoreEnforcement}
            duplicateBarcodeError={props.errMap[itemKey].dupError}
            invalidBarcodeError={props.errMap[itemKey].invalidError}
            barcodeGapError={props.errMap[itemKey].gapError}
            backgroundColor={props.currentSampleId === itemKey ? '#829AB1' : null}
            barcodeHandler={props.barcodeHandler}
            sampleHandler={props.sampleHandler}
            moveSample={props.moveSample}
            allBoxes={props.allBoxes}
            currentSampleId={props.currentSampleId}
            photos={photos}
            onCoresButtonClick={props.mission.isManualMeasurementRequired() ? props.onCoresButtonClick : undefined}
          />
        </div>
      );
    };

    return (
      <div style={{ display: 'block', height: '100vh' }}>
        <Virtuoso style={{ height: '100%' }} data={labelsOrdered} itemContent={itemContent} />
      </div>
    );
  }),
);
